var _regeneratorRuntime = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

/* 
   constructor should define the pacakage's name 
   by default this will be added to the x-powered-by header of all responses
*/
var SolidLocalStorage = /*#__PURE__*/function () {
  "use strict";

  function SolidLocalStorage() {
    _classCallCheck(this, SolidLocalStorage);

    this.prefix = "ls";
    this.name = "solid-rest-localStorage-1.0.0";
    localStorage.setItem("/", " ");
  }
  /*
     getObjectType(pathname,options)
       * trys to find pathname in storage
       * if found, sets exists to true
       * sets type to "Container" or "Resource" or undefined
       * returns an array [type,exists]
  */


  _createClass(SolidLocalStorage, [{
    key: "getObjectType",
    value: function () {
      var _getObjectType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(pathname, options) {
        var type, exists, keys, k, item;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                type = pathname.match(/\/$/) ? "Container" : "Resource";
                pathname = pathname.replace(/\/$/, ''); // REMOVE TRAILING SLASH

                exists = false;
                keys = Object.keys(localStorage);
                _context.t0 = _regeneratorRuntime.keys(keys);

              case 5:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 16;
                  break;
                }

                k = _context.t1.value;
                item = keys[k];

                if (!(type === "Container" && item.startsWith(pathname))) {
                  _context.next = 11;
                  break;
                }

                exists = true;
                return _context.abrupt("break", 16);

              case 11:
                if (!(item === pathname)) {
                  _context.next = 14;
                  break;
                }

                exists = true;
                return _context.abrupt("break", 16);

              case 14:
                _context.next = 5;
                break;

              case 16:
                return _context.abrupt("return", [type, exists]);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getObjectType(_x, _x2) {
        return _getObjectType.apply(this, arguments);
      }

      return getObjectType;
    }()
    /*
      getResource(pathname,options)
        * gets a resource
        * on success, returns [ 200, resourceContents, optionalHeader ]
        * on failure, returns [ 500, undefined, optionalHeader ]
    */

  }, {
    key: "getResource",
    value: function () {
      var _getResource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(pathname, options) {
        var body;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                body = localStorage.getItem(pathname);
                return _context2.abrupt("return", Promise.resolve([200, body]));

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);
                Promise.resolve([500]);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 5]]);
      }));

      function getResource(_x3, _x4) {
        return _getResource.apply(this, arguments);
      }

      return getResource;
    }()
    /*
      getContainer(pathname,options)
        * returns an array of the container's contained resource names
        * OR returns a turtle representation of the container and contents
    */

  }, {
    key: "getContainer",
    value: function () {
      var _getContainer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(pathname, options) {
        var files;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                files = Object.keys(localStorage).filter(function (path) {
                  return path.startsWith(pathname) && path != pathname;
                }) // Only children
                .map(function (path) {
                  return path.substr(pathname.length);
                }).filter(function (path) {
                  return !path.slice(0, -1).includes("/");
                }); // Only include direct children

                return _context3.abrupt("return", files);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getContainer(_x5, _x6) {
        return _getContainer.apply(this, arguments);
      }

      return getContainer;
    }()
  }, {
    key: "dump",
    value: function dump(pathname, options) {
      var keys = Object.keys(localStorage).filter(function (k) {
        if (!k.match(/(setItem|getItem|removeItem)/)) return k;
      }).map(function (m) {
        console.log(m, localStorage.getItem(m));
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this = this;

      var keys = Object.keys(localStorage).filter(function (k) {
        if (!k.match(/(setItem|getItem|removeItem)/)) return k;
      }).map(function (item) {
        _this.deleteResource(item);
      });
    }
    /*
       putResource(pathname,options)
         * creates a single Resource
         * on success : status = 201
         * on error : status = 500
         * returns [status,undefined,optionalHeader]
    */

  }, {
    key: "putResource",
    value: function () {
      var _putResource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(pathname, options) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                options = options || {};
                options.body = options.body || "";
                _context4.prev = 2;
                localStorage.setItem(pathname, options.body);
                return _context4.abrupt("return", Promise.resolve([201]));

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](2);
                console.log(_context4.t0);
                return _context4.abrupt("return", Promise.resolve([500]));

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 7]]);
      }));

      function putResource(_x7, _x8) {
        return _putResource.apply(this, arguments);
      }

      return putResource;
    }()
    /*
       postContainer(pathname,options)
          * creates a single Container
          * on success : status = 201
          * on error : status = 500
          * returns [status,undefined,optionalHeader]
    */

  }, {
    key: "postContainer",
    value: function () {
      var _postContainer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(pathname, options) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                pathname = pathname + '/'; // because wasn't on slug

                return _context5.abrupt("return", this.putResource(pathname, options));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function postContainer(_x9, _x10) {
        return _postContainer.apply(this, arguments);
      }

      return postContainer;
    }()
    /*
      deleteResource(pathname,options)
        * deletes a resource
        * on success, returns [200,undefined,optionalHeader]
        * on failure, returns [500,undefined,optionalHeader]
    */

  }, {
    key: "deleteResource",
    value: function () {
      var _deleteResource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(pathname, options) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                localStorage.removeItem(pathname);
                return _context6.abrupt("return", Promise.resolve([200]));

              case 5:
                _context6.prev = 5;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", Promise.resolve([500]));

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 5]]);
      }));

      function deleteResource(_x11, _x12) {
        return _deleteResource.apply(this, arguments);
      }

      return deleteResource;
    }()
    /*
      deleteContainer(pathname,options)
        * if container is not empty, returns [409,undefined,optionalHeader]
        * else deletes container
        * on success, returns [200,undefined,optionalHeader]
        * on failure, returns [500,undefined,optionalHeader]
    */

  }, {
    key: "deleteContainer",
    value: function () {
      var _deleteContainer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(pathname, options) {
        var files;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.getContainer(pathname, options);

              case 2:
                files = _context7.sent;

                if (!files.length) {
                  _context7.next = 5;
                  break;
                }

                return _context7.abrupt("return", Promise.resolve([409]));

              case 5:
                _context7.next = 7;
                return this.deleteResource(pathname, options);

              case 7:
                return _context7.abrupt("return", _context7.sent);

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function deleteContainer(_x13, _x14) {
        return _deleteContainer.apply(this, arguments);
      }

      return deleteContainer;
    }()
  }, {
    key: "makeContainers",
    value: function () {
      var _makeContainers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(pathname, options) {
        var inexistentParents, curParent;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                inexistentParents = []; // Get all parents which need to be created

                curParent = getParent(pathname);

              case 2:
                _context8.t0 = curParent;

                if (!_context8.t0) {
                  _context8.next = 7;
                  break;
                }

                _context8.next = 6;
                return this.getObjectType(curParent);

              case 6:
                _context8.t0 = !_context8.sent[1];

              case 7:
                if (!_context8.t0) {
                  _context8.next = 12;
                  break;
                }

                inexistentParents.push(curParent);
                curParent = getParent(curParent);
                _context8.next = 2;
                break;

              case 12:
                if (curParent) {
                  _context8.next = 14;
                  break;
                }

                return _context8.abrupt("return", [500]);

              case 14:
                if (!inexistentParents.length) {
                  _context8.next = 19;
                  break;
                }

                _context8.next = 17;
                return this.postContainer(inexistentParents.pop().slice(0, -1));

              case 17:
                _context8.next = 14;
                break;

              case 19:
                return _context8.abrupt("return", [201]);

              case 20:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function makeContainers(_x15, _x16) {
        return _makeContainers.apply(this, arguments);
      }

      return makeContainers;
    }()
  }]);

  return SolidLocalStorage;
}();
/**
 * return parent url with / at the end.
 * If no parent exists return null
 * @param {string} url 
 * @returns {string|null}
 */


function getParent(url) {
  while (url.endsWith('/')) {
    url = url.slice(0, -1);
  }

  if (!url.includes('/')) return null;
  return url.substring(0, url.lastIndexOf('/')) + '/';
}
/* 
  OPTIONAL METHODS

  see solid-rest.js code for examples of the defaults
  optionally provide your own to replace or augment the behavior

   text(stream)
     * response method to pipe text body
     * receives response body, returns piped string
   json(string)
     * response method to parse json body
     * receives response body returns a json object
   container2turtle(pathname,options,contentsArray)
     * iterates over container's contents, creates a turtle representation
     * returns [200, turtleContents, optionalHeader]
   getHeaders(pathname,options)
     * returns header fields to replace or augment default headers
*/

/*
  if it should work in nodejs, export the object
*/


if (typeof window === "undefined") {
  alert = function alert(msg) {
    return console.log(msg);
  };

  localStorage = {
    getItem: function getItem(key) {
      return localStorage[key];
    },
    removeItem: function removeItem(key) {
      delete localStorage[key];
    },
    setItem: function setItem(key, val) {
      localStorage[key] = val;
    }
  };
  module.exports = SolidLocalStorage;
}